import React from "react"
import XGSInput from "../../../xgs-input/xgsInput";

interface DefaultColumnFilterPros {
    column: any
}

export const DefaultColumnFilter: React.FC<DefaultColumnFilterPros> = ({
    column
}) => {
    return (
        <XGSInput
            value={column.getFilterValue() || ''}
            onChange={(e) => {
                column.setFilterValue((e.target as HTMLInputElement).value || undefined);
            }}
            placeholder="Search..."
        />
    );
};
